import React from 'react'

import { Tab } from 'components'

import { SearchDocumentation } from './components'
// import { Container } from './styles';

const tabs = ['Pesquisar']

const DocumentationFile: React.FC = () => {
  const [selectedTab, setSelectedTab] = React.useState(0)

  const handleChange = (_: any, newValue: React.SetStateAction<number>) =>
    setSelectedTab(newValue)

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 && <SearchDocumentation />}
    </>
  )
}

export default DocumentationFile
